import { TicketDetailPageState } from ".";
import { GetInfraTaskTicketResponse } from "../../services/ticket/get-infra-task-ticket/GetInfraTaskResponse";
import { INIT_ERROR_RESULT_DATA } from "../../util";
import {
  TcktStsTypeCpntOtherStgStupTask,
  TcktStsTypeCpntPrdStupTask,
  TcktStsTypeCpntStgStupTask,
} from "../../util/general-code/enums/general-codes";

const fieldPath = {
  dueDate: "dueDate",
  tcktSts: "tcktSts",
  desc: "desc",
};

const displayColumn = [
  { label: "Protocol Category(Lv3)", value: "cpntPrtclCtgryTypeName" },
  { label: "Protocol(Lv4)", value: "prtclTypeName" },
  { label: "Task(Lv5)", value: "stupTaskName" },
  { label: "Task Owner Role", value: "roleName" },
  { label: "Necessity Flag", value: "necFlg" },
];

export const ticketDetailInitialState: GetInfraTaskTicketResponse = {
  tcktId: "",
  envrnmntId: "",
  roleCd: "",
  tcktName: "",
  tcktTypeTypeCd: "",
  tcktTypeTypeName: "",
  pjtId: "",
  pjtName: "",
  dueDate: "",
  teamId: "",
  updateDateTime: "",
  tcktStsTypeCd: "",
  tcktStsTypeName: "",
  tcktDesc: "",
  stupTasksList: [],
  tcktDescList: [],
};

export const ticketDetailPageInitialState: TicketDetailPageState = {
  searchResult: ticketDetailInitialState,
  tcktStsList: [],
  dataList: {
    tcktStsTypeCpntStgStupTask: Object.entries(TcktStsTypeCpntStgStupTask).map(
      ([key, value]) => ({
        label: key,
        value: value,
      }),
    ),
    tcktStsTypeCpntPrdStupTask: Object.entries(TcktStsTypeCpntPrdStupTask).map(
      ([key, value]) => ({
        label: key,
        value: value,
      }),
    ),
    tcktStsTypeCpntOtherStgStupTask: Object.entries(
      TcktStsTypeCpntOtherStgStupTask,
    ).map(([key, value]) => ({
      label: key,
      value: value,
    })),
    inDefCommonFlagType: [],
    roleType: [],
  },
  formValidation: {
    dueDate: true,
    tcktStsTypeCd: true,
    tcktDesc: true,
  },
  fieldPath: fieldPath,
  displayColumn: displayColumn,
  spreadsheet: {
    tmplateRow: {
      ...INIT_ERROR_RESULT_DATA,
      stupTaskCtgryId: "",
      cpntPrtclCtgryTypeCd: "",
      cpntPrtclCtgryTypeName: "",
      prtclTypeCd: "",
      prtclTypeName: "",
      updateDateTime: "",
      stupTaskList: [],
    },
  },
  isEdited: false,
};
